import { httpClient } from '../httpClient'
import { type SubmittalDocList } from '../types'
import { WorkflowStepBoundingBoxResult } from './workflowStepResult'

export interface DocListParams {
  projectId: number
  body: {
    drawingId: number
    stecsId: number
  }
}

export async function createDocList(params: DocListParams) {
  if (params.projectId === 0) {
    throw new Error('Project Id are required')
  }

  const { projectId, body } = params

  const response = await httpClient<SubmittalDocList>(
    `/api/v2/submittal/projects/${projectId}/doc-list`,
    {
      method: 'POST',
      body: JSON.stringify({
        drawing_doc_id: body.drawingId,
        specs_doc_id: body.stecsId
      })
    }
  )

  return response
}

export interface ResultUpload {
  result_type: 'upload'
  doc_id: number
}

export interface ResultBoundingBox {
  result_type: 'bounding_box'
  document_bounding_box: {
    doc_id: number
    page_ix: number //page number
    bounding_box_coordinate_type: 'pdf' | 'PDF'
    bounding_box: {
      xmin: number
      ymin: number
      xmax: number
      ymax: number
    }
  }
}

export interface UpdateWorkflowStepResultParams {
  projectId: number
  workflowInstanceId: string
  stepIndex: number
  result: ResultUpload | ResultBoundingBox | WorkflowStepBoundingBoxResult
}

export async function updateWorkflowStepResult(
  params: UpdateWorkflowStepResultParams
): Promise<string> {
  if (!params.projectId || !params.workflowInstanceId) {
    throw new Error('Project ID, workflow instance ID, and step index are required')
  }

  const { projectId, workflowInstanceId, stepIndex, result } = params

  const response = await httpClient<string>(
    `/api/v2/submittal/projects/${projectId}/workflows/${workflowInstanceId}/step/${stepIndex}/result`,
    {
      method: 'POST',
      body: JSON.stringify({ result })
    }
  )

  return response
}

export async function getReportUrl(projectId: string, workflowInstanceId: string) {
  const response = await httpClient<{
    report_url: string
  }>(
    `/api/v2/submittal/projects/${projectId}/workflows/${workflowInstanceId}/get-final-report?report_name=compliance_report_summary.pdf`,
    {
      method: 'GET'
    }
  )

  return response
}

export interface PrecheckSubmittalList {
  spec_section_precheck_document_file_path: string
  spec_section_precheck_document_name: string
  spec_section_precheck_document_signed_url: string
}

export async function getPrecheckSubmittalList(projectId: string) {
  const response = await httpClient<PrecheckSubmittalList[]>(
    `/api/v2/submittal/projects/${projectId}/get-precheck-submittal-list`,
    {
      method: 'GET'
    }
  )

  return response
}
